/**
 * Cleans an ID card number by removing all non-alphanumeric characters.
 * Keeps only letters (A-Z, a-z) and numbers (0-9).
 * 
 * Examples:
 *   "12.34.56-789.01" → "12345678901"
 *   "AB-123 456" → "AB123456"
 *   "12 34 56-789 01" → "12345678901"
 * 
 * @param {string} idCardNumber - The ID card number to clean
 * @returns {string} - Cleaned ID card number with only alphanumeric characters
 */
export function cleanIdCardNumber(idCardNumber) {
	if (!idCardNumber || typeof idCardNumber !== 'string') {
		return idCardNumber;
	}
	
	// Remove all characters that are not letters or numbers
	return idCardNumber.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
}
